<div class="capital-card h-100" [class.shadow-normal]="shadow() === 'normal'" [class.shadow-small]="shadow() === 'small'">
    <ng-content></ng-content>
</div>